// Yıllık izin iş günü hesabı: Pzt–Cmt dahil, resmi tatiller hariç, işbaşı günü (end) hariç
const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const holidaySets = (list = []) => ({
  fixed: new Set(list.filter((h) => h.recurring).map((h) => h.date.slice(5))),
  dated: new Set(list.filter((h) => !h.recurring).map((h) => h.date)),
});

export const leaveWorkdays = (start, end, sets) => {
  if (!start || !end) return null;
  const d = new Date(start + "T00:00:00"), e = new Date(end + "T00:00:00");
  if (!(e > d)) return null;
  let n = 0;
  for (; d < e; d.setDate(d.getDate() + 1)) {
    const iso = isoOf(d);
    if (d.getDay() !== 0 && !sets?.fixed?.has(iso.slice(5)) && !sets?.dated?.has(iso)) n++;
  }
  return n;
};
